// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"qm-z","badgeLink":"rm-z","category":"sm-z"};